import { DesktopLogo } from 'src/components/Header/svg/DesktopLogo';
import desktopLogoEvent from 'src/assets/images/event/desktopLogoEvent.webp';

export const HeaderLogo = () => {
  const isEventActive = false;

  return isEventActive ? (
    <img src={desktopLogoEvent} className="hidden 1024:block w-[150px] h-full object-contain" />
  ) : (
    <DesktopLogo />
  );
};
